jQuery(function ($) {
  $('.js-mfp-contact').magnificPopup({
    type: 'inline',
    preloader: false,
  });
  $('.contactbtn').on('click', function () {
    let field = $(this).data('field');
    let contact_id = $(this).data('id');
    let title = $(this).data('title');

    $('#' + field).val(contact_id);
    $('#popup-contact').find('h3').html(title);
  });
});
